// extracted by mini-css-extract-plugin
module.exports = {"deleteBtn":"schedule_table_deleteBtn__3BI1r","viewButton":"schedule_table_viewButton__1PUhk"};